import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es7.symbol.async-iterator.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.slice.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { usePatternFormatter } from './use-pattern-formatter'; // Wrapper for Input component that manages:
//   - formatting an input value to a pattern as the user types
//   - redacting some or all of the value that is visible to the user
//   - applying a mask after the value to hint at what remains
//   - providing the formatted value without redaction or mask to onChange

export var InputFormattedPattern = function InputFormattedPattern(_ref) {
  var formatPattern = _ref.formatPattern,
      redaction = _ref.redaction,
      mask = _ref.mask,
      onChange = _ref.onChange,
      defaultValue = _ref.defaultValue,
      valueProp = _ref.value,
      Component = _ref.component,
      props = _objectWithoutProperties(_ref, ["formatPattern", "redaction", "mask", "onChange", "defaultValue", "value", "component"]);

  var initialValue = "".concat(valueProp || defaultValue || '');

  var _usePatternFormatter = usePatternFormatter({
    formatPattern: formatPattern,
    initialValue: initialValue,
    onChange: onChange
  }),
      _usePatternFormatter2 = _slicedToArray(_usePatternFormatter, 3),
      formatter = _usePatternFormatter2[0],
      inputRef = _usePatternFormatter2[1],
      onInputChange = _usePatternFormatter2[2]; // apply masking and redactions


  var value = formatter.value;

  if (value.length) {
    // apply the redaction
    var redacted = redaction.slice(0, formatter.format(value).length);
    value = redacted + value.slice(redacted.length, value.length); // apply the mask

    value += mask.slice(value.length, mask.length);
  }

  return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    ref: inputRef,
    onChange: onInputChange,
    value: value
  }));
};
InputFormattedPattern.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // formatPattern:
  //  '9' is numeral
  //  'a' is alpha
  //  'x' is alphanumeric
  //  any other character is a delimiter in the pattern
  formatPattern: PropTypes.string.isRequired,
  // redaction:
  //  string to apply over input value as the user types
  redaction: PropTypes.string,
  // mask: string to hint at remaining characters the user should type
  mask: PropTypes.string,
  // onChange: function to be called when input value changes. called with unredacted, unmasked, still formatted e.target.value
  onChange: PropTypes.func,
  // a Component that forwards the 'ref' to an underlying input or textarea component
  component: PropTypes.elementType
};
InputFormattedPattern.defaultProps = {
  redaction: '',
  mask: '',
  onChange: function onChange() {},
  component: 'input'
};